// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_BcR","cls2":"FeedbackModal-cls2_hvr FeedbackModal-cls1_BcR"};